import bgImage from '../../assets/RideLoginBackground.png';

const styles = theme => ({
  root: {
  	width: '100%',
  	height: '100%',
  	background: `URL('${bgImage}') no-repeat fixed`,
  	backgroundSize: 'cover',
  },
  main: {
    width: '400px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '150px',
    padding: '30px',
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: '100%',
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
    padding: 0,
    '& .MuiInputBase-multiline': {
        padding: '6px 0 7px 10px'
    }
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing(1),
  },
  labelTitle: {
    margin: 0,
    fontWeight: '700',
    fontSize: '1.8em',
    color: theme.palette.secondary.contrastText,
    textAlign: 'center'
  },
  labelCaption: {
    margin: 0,
    fontWeight: '700',
    fontSize: '14px',
    color: theme.palette.primary.contrastText
  },
  validationLabel: {
    color: theme.palette.secondary.light,
    paddingLeft: '8px',
  },
  logo: {
    width: '80%'
  },
  h2: {
    padding: 0,
    textAlign: 'center'
  },
  actions: {
  	width: '100%',
  	textAlign: 'center'
  },
  rating: {
    display: 'flex',
    padding: '1em 0',
    justifyContent: 'center',
    '& .MuiRating-root': {
      fontSize: '2.5em',
      color: theme.palette.secondary.light,
    }
  }
});

export default styles;
